export type NotifiersType = {
  id: string;
  data: Flights[];
  loading: boolean;
  flight: Flights | null;
  bookings: Booking[];
};

export const initialState: NotifiersType = {
  id: "",
  data: [],
  loading: false,
  flight: null,
  bookings: [],
};

export type Flights = {
  flights: Depature[];
  total_duration: number;
  carbon_emissions: {
    this_flight: number;
    typical_for_this_route: number;
    difference_percent: number;
  };
  type: string;
  airline_logo: string;
  booking_token: string;
  departure_token: string;
  price: number;
};

export type Depature = {
  departure_airport: {
    name: string;
    id: string;
    time: string;
  };
  arrival_airport: {
    name: string;
    id: string;
    time: string;
  };
  duration: number;
  airplane: string;
  airline: string;
  airline_logo: string;
  travel_class: string;
  flight_number: string;
  extensions: string[];
};

export type Booking = {
  id: string;

  departure_id: string;
  arrival_id: string;
  created_at: string;
  updated_at: string;
  outbound_date: null;
  booking_status: null;
  transaction_id: string;
  transaction_status: "PENDING" | "APPROVED" | "CANCELLED";
  transaction_reference: string;
  transaction_amount: number;
};
